/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Refresh_TitleInputs */

const en_tags_refresh_title = /** @type {(inputs: Tags_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refresh`)
};

const fr_tags_refresh_title = /** @type {(inputs: Tags_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualiser`)
};

const de_tags_refresh_title = /** @type {(inputs: Tags_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualisieren`)
};

const it_tags_refresh_title = /** @type {(inputs: Tags_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna`)
};

const ru_tags_refresh_title = /** @type {(inputs: Tags_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновить`)
};

const es_tags_refresh_title = /** @type {(inputs: Tags_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refrescar`)
};

const zh_cn2_tags_refresh_title = /** @type {(inputs: Tags_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`刷新`)
};

const ja_tags_refresh_title = /** @type {(inputs: Tags_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リフレッシュ`)
};

const hi_tags_refresh_title = /** @type {(inputs: Tags_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ताज़ा करना`)
};

const pt_pt2_tags_refresh_title = /** @type {(inputs: Tags_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizar`)
};

/**
* | output |
* | --- |
* | "Refresh" |
*
* @param {Tags_Refresh_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_refresh_title = /** @type {((inputs?: Tags_Refresh_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Refresh_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tags_refresh_title(inputs)
	if (locale === "de") return de_tags_refresh_title(inputs)
	if (locale === "it") return it_tags_refresh_title(inputs)
	if (locale === "ru") return ru_tags_refresh_title(inputs)
	if (locale === "es") return es_tags_refresh_title(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_refresh_title(inputs)
	if (locale === "ja") return ja_tags_refresh_title(inputs)
	if (locale === "hi") return hi_tags_refresh_title(inputs)
	if (locale === "pt-PT") return pt_pt2_tags_refresh_title(inputs)
	return en_tags_refresh_title(inputs)
});